module.exports = __webpack_public_path__ + "static/media/icon_05.4a4e3e1e.png";